<template>
    <div id="organismForm" class="col-12 my-4">
        <p class="mb-4 text-left title-group">Campos do Card</p>

        <div class="item-control text-start mb-3">
            <label class="position-absolute">Itens por linha</label>
            <input
                type="number"
                min="1" max="6"
                v-model="data.items_per_line"
            />
        </div>

        <draggable
            :list="data.items"
            @start="drag = true"
            @end="drag = false"
            v-bind="{ handle: '.handle' }"
            :force-fallback="true"
        >
            
            <div
                v-for="(item, index) in data.items"
                :key="item.id"
                class="item-control border-item mb-3"
                :class="!item.show ? 'handle' : ''"
            >
                <div class="d-flex align-items-center justify-content-between mx-2">
                    <p class="my-0 w-100 cursor-pointer" @click="showItem(item)">
                        {{ titleItem(item) }}
                    </p>
                    <span class="item-settings-button" @click="modalDelete(index)">
                        <i class="fal fa-trash-alt"></i>
                    </span>
                </div>

                <template v-if="item.show">
                    <div
                        class="image-box mb-3"
                        @click="(mediaManagerOpen = true), (mediaManagerTarget = item.id)"
                    >
                        <BaseImage
                            v-if="item.image"
                            :customClass="'img-fluid rounded pointer h-100'"
                            :source="item.image.url"
                            :fitIn="'0x300'"
                        />
                        <img
                            v-else
                            class="img-fluid rounded pointer h-100"
                            src="@/assets/img/default-image.png"
                        />
                    </div>

                    <div class="item-control text-start mb-3" :id="`title-${index}`">
                        <label class="position-absolute">Título</label>
                        <input
                            type="text"
                            v-model="item.title"
                            placeholder="Digite o título aqui..."
                        />
                    </div>

                    <div class="item-control text-start mb-3" :id="`subtitle-${index}`">
                        <label class="position-absolute">Subtítulo</label>
                        <input
                            type="text"
                            v-model="item.subtitle"
                            placeholder="Digite o subtítulo aqui..."
                        />
                    </div>

                    <div class="item-control text-start mb-3" :id="`sub-${index}`">
                        <label class="position-absolute">Texto</label>
                        <TinyEditor
                            :textContent="item.text"
                            @contentText="item.text = $event"
                            customClass="mt-4 col-12 px-0"
                            :heightEditor="100"
                            placeholder="Digite o texto aqui..."
                        ></TinyEditor>
                    </div>

                    <div class="item-control text-start mb-3" :id="`highlight-${index}`">
                        <label class="position-absolute">Texto em Destaque</label>
                        <input
                            type="text"
                            v-model="item.highlight"
                            placeholder="Digite o título aqui..."
                        />
                    </div>

                    <div class="item-control text-start mb-3 py-0" :id="`url-${index}`">
                        <CheckBox
                            label="URL de destino"
                            :visible="item.link.show"
                            @onCheck="item.link.show = $event"
                        />
                        <div v-if="item.link.show" class="item-control text-start mb-3">
                            <label class="position-absolute">URL</label>
                            <input
                                type="text"
                                v-model="item.link.href"
                                placeholder="https://www."
                            />
                        </div>
                        <div v-if="item.link.show" class="item-control text-start mb-3">
                            <label class="position-absolute">Abrir em</label>
                            <select v-model="item.link.target">
                                <option value="_self">Mesma aba</option>
                                <option value="_blank">Nova aba</option>
                            </select>
                        </div>
                    </div>

                    <div
                        class="item-control text-start mb-3"
                        v-for="(button, index) in item.buttons"
                        :key="index"
                    >
                        <div class="d-flex justify-content-center align-items-center">
                            <p class="text-center my-auto">{{ button.text }}</p>
                            <span
                                class="item-settings-button"
                                @click="item.buttons.splice(index, 1)"
                            >
                                <i class="fal fa-trash-alt"></i>
                            </span>
                        </div>
                        <div class="item-control text-start mb-3">
                            <label class="position-absolute">Texto do botão</label>
                            <input
                                type="text"
                                v-model="button.text"
                                placeholder="Digite o texto do botão."
                            />
                        </div>
                        <div class="item-control text-start mb-3">
                            <label class="position-absolute">URL</label>
                            <input
                                type="text"
                                v-model="button.href"
                                placeholder="https://www."
                            />
                            </div>
                            <div class="item-control text-start mb-3">
                            <label class="position-absolute">Abrir em</label>
                            <select v-model="button.target">
                                <option value="_self">Mesma aba</option>
                                <option value="_blank">Nova aba</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="item.buttons.length < 3" class="col-12 text-center mb-2">
                        <button
                            class="btn px-4 btn-primario btn-small"
                            @click="newButton(item.buttons)"
                        >
                        Adicionar Botão
                        </button>
                    </div>
                </template>
            </div>
        </draggable>

        <div class="col-12 text-center mt-2">
            <button class="btn px-4 btn-primario btn-small" @click="newItem()">
                Novo Item
            </button>
        </div>

        <div v-if="mediaManagerOpen" class="media--manager">
            <div class="nav-mediaManager p-4">
                <i class="fas fa-chevron-down" @click="mediaManagerOpen = false"></i>
            </div>
            <MediaManager @receiveMedias="addPictures($event)" />
        </div>
    </div>
</template>
 
<script>
import draggable from "vuedraggable";
import TinyEditor from "@/components/organisms/TinyEditor.vue";
import MediaManager from "@/components/organisms/MediaManager";
import BaseImage from "@/components/atoms/BaseImage";
import CheckBox from "@/components/atoms/checkBox";

export default {
    name: "organismForm",
    props: {
        cardListContent: {
            type: Object,
            required: true,
        },
    },
    components: {
        BaseImage,
        MediaManager,
        TinyEditor,
        CheckBox,
        draggable,
    },
    data() {
        return {
            mediaManagerOpen: false,
            data: {},
            showAlert: false,
            mediaManagerTarget: "",
        };
    },
    created() {
        this.data = this.cardListContent.frameContent;
    },
    methods: {
        titleItem(item) {
            if (item.title) return this.limitCaractere(item.title);
            else if (item.subtitle) return this.limitCaractere(item.subtitle);
            else if (item.text) return this.limitCaractere(item.text);
            else return "Novo Item";
            },
            limitCaractere(content) {
            content = content.replace(/(<([^>]+)>|(\&nbsp\;))/gi, "");
            if (content.length > 35) {
                content = content.replace(/^([\s\S]{1,35})[\s]+?[\s\S]+/, "$1");
                return content + "...";
            }
            return content;
        },
        modalDelete(index) {
            this.$bvModal
                .msgBoxConfirm("Deseja realmente remover este conteúdo?", {
                title: "Confirmar exclusão",
                size: "md",
                buttonSize: "sm",
                cancelVariant: "danger",
                okTitle: "Remover",
                cancelTitle: "Cancelar",
                footerClass: "p-2",
                hideHeaderClose: true,
                centered: true,
                })
                .then((value) => {
                    value && this.data.items.splice(index, 1);
                });
        },
        newItem() {
            const newItem = {
                id: `card_list${this.data.items.length + 1}`,
                image: null,
                title: "",
                subtitle: "",
                text: "",
                highlight: "",
                link: {
                show: false,
                href: "/link_card",
                target: "_blank",
                },
                buttons: [
                    {
                        text: "Botão",
                        href: "/link_botao",
                        target: "_blank",
                    },
                ],
            };
            this.data.items.push(newItem);
            const item = this.data.items[this.data.items.length - 1];
            this.showItem(item);
        },
        newButton(item) {
            const newButton = {
                text: "Botão",
                href: "/link_botao",
                target: "_blank",
            };
            item.push(newButton);
        },
        showItem(item) {
            this.data.items.forEach((e) => {
                this.$set(e, "show", e.id == item.id ? true : false);
            });
        },
        //Add imagem ao card
        addPictures(files) {
            if (files) {
                this.data.items.forEach((e) => {
                if (e.id == this.mediaManagerTarget) {
                    e.image = {}
                    e.image.url = files[0].url
                }
                });
            }
            this.mediaManagerOpen = false;
        }
    },
};
</script>

<style scoped>
.media--manager {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: white;
  overflow-y: scroll;
  overflow-x: hidden;
}

.image-box {
  height: 80px;
  width: 100%;
  text-align: center;
}

.item-control {
  padding: 5px;
  width: 100%;
  height: 100%;
  font-size: 1rem;
  -moz-appearance: none;
  border-radius: 0.25rem;
}

.item-control.border-item {
  border: 1px solid #ced4da;
}

label {
  font-weight: 700;
  font-size: 12px;
  color: #555555;
}

.item-control input,
.item-control select {
  padding: 25px 10px 0;
  border: none;
  margin-bottom: -1px;
}
input {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/CardListComponent.vue